module.exports = __webpack_public_path__ + "img/70cd9aa.svg";